import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  text?: string;
  className?: string;
  href?: string;
  onClick?: () => void;
}
export function CTAButton({
  text = 'QUIERO SER MAGNÉTICA AHORA',
  className = '',
  href,
  onClick
}: CTAButtonProps) {
  const sharedProps = {
    whileHover: {
      scale: 1.02
    },
    whileTap: {
      scale: 0.98
    },
    animate: {
      boxShadow: ['0px 0px 0px 0px rgba(201, 168, 76, 0)', '0px 0px 20px 5px rgba(201, 168, 76, 0.3)', '0px 0px 0px 0px rgba(201, 168, 76, 0)']
    },
    transition: {
      boxShadow: {
        duration: 2,
        repeat: Infinity,
        ease: 'easeInOut' as const
      }
    },
    className: `inline-block text-center bg-gold hover:bg-gold-light text-dark font-sans font-bold py-4 px-8 rounded-sm tracking-wider transition-colors duration-300 uppercase text-sm md:text-base w-full md:w-auto cursor-pointer ${className}`
  };
  if (href) {
    return <motion.a href={href} target="_blank" rel="noopener noreferrer" onClick={onClick} {...sharedProps} data-id="element-17">
        {text}
      </motion.a>;
  }
  return <motion.button onClick={onClick} {...sharedProps} data-id="element-18">
      {text}
    </motion.button>;
}